export default [
    {
        'from': ' pixels',
        'to': 'pixels'
    },
    {
        'from': 'pixels',
        'to': 'px'
    },
    {
        'from': ' percent',
        'to': 'percent'
    },
    {
        'from': 'percent',
        'to': '%'
    }
]


// WEBPACK FOOTER //
// ./src/fixtures/KeywordsToReplace2.js